// Author Shi Wen Long
// Date 2021-08-25 12:04:20

import * as model from "@/model/sithMes/prd/SithMesPrdSdProjectNetworkModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesPrdSdProjectNetwork(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_PRD_URL,
    })
    .buildStore()
